import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import {
  featureAccessAreReady,
  featureAccessGetAll,
  featureAccessIsActive,
} from 'mojo-feature-access';
import { filter, map, Observable, switchMap, take } from 'rxjs';
import { REPORT_PAGES, ReportPage } from '@app/shared/config/reports.config';

@Injectable({
  providedIn: 'root',
})
export class FastrFeatureAccessService {
  private store = inject(Store);

  /*
    Do not use featureAccessIsActive selector directly
    as it may return false value before feature access data is ready.
   */
  hasFeatureAccess(featureAccess: string): Observable<boolean> {
    return this.store.select(featureAccessAreReady).pipe(
      filter(Boolean),
      take(1),
      switchMap(() => this.store.select(featureAccessIsActive(featureAccess))),
    );
  }

  getAccessibleReports(): Observable<ReportPage[]> {
    return this.store.select(featureAccessAreReady).pipe(
      filter(Boolean),
      take(1),
      switchMap(() => this.store.select(featureAccessGetAll)),
      map((accessList: string[]) =>
        REPORT_PAGES.filter(({ access }) => accessList.includes(access)),
      ),
    );
  }
}
